import { escapeReact } from "@utils/react";
import React, { useCallback, useMemo } from "react";

// Function to convert markdown to HTML
const MarkdownRenderer = ({ markdown }) => {
  const convertToHTML = useCallback(text => {
    if (!text) return "";

    // Combined regex for all markdown patterns
    const patterns = [
      // Headings
      [/^#{6} (.*)$/gm, "<h6>$1</h6>"],
      [/^#{5} (.*)$/gm, "<h5>$1</h5>"],
      [/^#{4} (.*)$/gm, "<h4>$1</h4>"],
      [/^#{3} (.*)$/gm, "<h3>$1</h3>"],
      [/^#{2} (.*)$/gm, "<h2>$1</h2>"],
      [/^#{1} (.*)$/gm, "<h1>$1</h1>"],
      // Bold
      [/\*\*(.*?)\*\*/g, "<b>$1</b>"],
      // Italic
      [/\*(.*?)\*/g, "<i>$1</i>"],
      // Underline
      [/__(.*?)__/g, "<u>$1</u>"],
      // Links
      [/\[([^\]]*)\]\(([^)]*)\)/g, '<a href="$2">$1</a>'],
      // Images
      [/!\[([^\]]*)\]\(([^)]*)\)/g, '<img src="$2" alt="$1" />'],
      // Blockquote
      [/^> (.*)$/gm, "<blockquote>$1</blockquote>"],
      // Code (inline)
      [/`(.*?)`/g, "<code>$1</code>"],
      // Code (block)
      [
        /^```[\s\S]*?^```$/gm,
        match => {
          const code = match.replace(/^```[\s]*|[\s]*```$/g, "");
          return `<pre><code>${code}</code></pre>`;
        }
      ],
      // Horizontal rule
      [/^[-*_]{3,}\s*$/gm, "<hr>"],
      // Ordered lists
      [
        /^(\d+\.\s+.*(?:\n\d+\.\s+.*)*)$/gm,
        match => {
          return `<ol>${match.replace(/^\d+\.\s+(.*)$/gm, "<li>$1</li>")}</ol>`;
        }
      ],
      // Unordered lists
      [
        /^([-*+]\s+.*(?:\n[-*+]\s+.*)*)$/gm,
        match => {
          return `<ul>${match.replace(/^[-*+]\s+(.*)$/gm, "<li>$1</li>")}</ul>`;
        }
      ],
      // Newlines to <br> except within lists
      [/(?<!<\/?(ul|ol|li)>\n*)\n/g, "<br>"]
    ];

    let html = text;
    for (const [regex, replacement] of patterns) {
      html = html.replace(regex, replacement);
    }

    return html;
  }, []);

  const htmlContent = useMemo(
    () => convertToHTML(markdown),
    [markdown, convertToHTML]
  );

  return <div>{escapeReact(htmlContent)}</div>;
};

export default MarkdownRenderer;
